export { default as CompactFreshFacesLocations } from './CompactFreshFacesLocations';
export { default as CompactFreshFacesLocationsPreview } from './CompactFreshFacesLocationsPreview';
